import { render, staticRenderFns } from "./qualityInspection.vue?vue&type=template&id=128a037e&scoped=true&"
import script from "./qualityInspection.vue?vue&type=script&lang=js&"
export * from "./qualityInspection.vue?vue&type=script&lang=js&"
import style0 from "./qualityInspection.vue?vue&type=style&index=0&id=128a037e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128a037e",
  null
  
)

export default component.exports